import { Container } from '@/components';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { JSX } from 'react';
import { GetFundsInner } from './parts';

export type GetFundsProps = SliceComponentProps<Content.GetFundsSlice>;

const GetFunds = ({ slice }: GetFundsProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
    >
      <Container>
        <GetFundsInner slice={slice} />
      </Container>
    </section>
  );
};

export default GetFunds;
